/* eslint-disable */
var Wysihtml5ParserRules = {
  keepComments: true,
  classes: 'any',
  tags: {
    tr: {
      check_attributes: {
        align: 'any',
        bgcolor: 'any',
        char: 'any',
        charoff: 'any',
        valign: 'any',
        width: 'any',
        style: 'any',
      },
      add_class: {
        align: 'align_text',
      },
    },
    strike: {
      check_attributes: {
        style: 'any',
      },
      remove: 0,
      rename_tag: '',
    },
    form: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'div',
    },
    rt: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    code: {
      check_attributes: {
        style: 'any',
      },
      remove: 0,
      rename_tag: '',
    },
    acronym: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    br: {
      check_attributes: {
        style: 'any',
      },
      remove: 0,
      rename_tag: '',
      add_class: {
        clear: 'clear_br',
      },
    },
    details: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'div',
    },
    h4: {
      check_attributes: {
        style: 'any',
      },
      add_class: {
        align: 'align_text',
      },
    },
    em: {
      check_attributes: {
        style: 'any',
      },
      remove: 0,
      rename_tag: '',
    },
    title: {
      remove: 0,
    },
    multicol: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'div',
    },
    figure: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'div',
    },
    xmp: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    small: {
      check_attributes: {
        style: 'any',
      },
      remove: 0,
      rename_tag: '',
    },
    area: {
      remove: 1,
    },
    time: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    dir: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'ul',
    },
    bdi: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    command: {
      remove: 1,
    },
    ul: {
      check_attributes: {
        style: 'any',
      },
    },
    progress: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    dfn: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    iframe: {
      remove: 1,
    },
    figcaption: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'div',
    },
    a: {
      check_attributes: {
        href: 'liquidURL',
        style: 'any',
      },
      set_attributes: {
        rel: false,
      },
    },
    img: {
      check_attributes: {
        src: 'liquidURL',
        border: 'any',
        align: 'any',
        alt: 'alt',
        height: 'numbers',
        style: 'any',
        title: 'any',
        width: 'any',
      },
      add_class: {
        align: 'align_img',
      },
    },
    rb: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    footer: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'div',
    },
    noframes: {
      remove: 1,
    },
    abbr: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    u: {
      check_attributes: {
        style: 'any',
      },
    },
    bgsound: {
      remove: 1,
    },
    sup: {
      check_attributes: {
        style: 'any',
      },
      remove: '0',
      rename_tag: '',
    },
    address: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'div',
    },
    basefont: {
      remove: 1,
    },
    nav: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'div',
    },
    h1: {
      check_attributes: {
        style: 'any',
      },
      add_class: {
        align: 'align_text',
      },
    },
    head: {
      remove: 1,
    },
    tbody: {
      check_attributes: {
        style: 'any',
      },
      add_class: {
        align: 'align_text',
      },
    },
    dd: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'div',
    },
    s: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    li: {
      check_attributes: {
        style: 'any',
      },
    },
    td: {
      check_attributes: {
        rowspan: 'numbers',
        colspan: 'numbers',
        abbr: 'any',
        align: 'any',
        axis: 'any',
        bgcolor: 'any',
        char: 'any',
        charoff: 'any',
        headers: 'any',
        scope: 'any',
        valign: 'any',
        width: 'any',
        style: 'any',
      },
      add_class: {
        align: 'align_text',
      },
    },
    object: {
      remove: 1,
    },
    div: {
      check_attributes: {
        align: 'any',
        width: 'any',
        style: 'any',
      },
      add_class: {
        align: 'align_text',
      },
    },
    option: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    select: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    i: {
      check_attributes: {
        style: 'any',
      },
      remove: 0,
      rename_tag: '',
    },
    track: {
      remove: 1,
    },
    wbr: {
      remove: 1,
    },
    fieldset: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'div',
    },
    big: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
      set_class: 'wysiwyg-font-size-larger',
    },
    button: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    noscript: {
      remove: 1,
    },
    svg: {
      remove: 1,
    },
    input: {
      remove: 1,
    },
    table: {
      check_attributes: {
        align: 'any',
        bgcolor: 'any',
        border: 'any',
        cellpadding: 'any',
        cellspacing: 'any',
        frame: 'any',
        rules: 'any',
        summary: 'any',
        width: 'any',
        style: 'any',
      },
    },
    keygen: {
      remove: 1,
    },
    h5: {
      check_attributes: {
        style: 'any',
      },
      add_class: {
        align: 'align_text',
      },
    },
    meta: {
      check_attributes: {
        'http-equiv': 'any',
        content: 'any',
        name: 'any',
      },
      remove: 0,
      rename_tag: '',
    },
    map: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'div',
    },
    isindex: {
      remove: 1,
    },
    mark: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    caption: {
      check_attributes: {
        style: 'any',
      },
      add_class: {
        align: 'align_text',
      },
    },
    tfoot: {
      check_attributes: {
        style: 'any',
      },
      add_class: {
        align: 'align_text',
      },
    },
    base: {
      remove: 1,
    },
    video: {
      remove: 1,
    },
    strong: {
      check_attributes: {
        style: 'any',
      },
      remove: 0,
      rename_tag: '',
    },
    canvas: {
      remove: 1,
    },
    output: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    marquee: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    b: {
      check_attributes: {
        style: 'any',
      },
      remove: 0,
      rename_tag: '',
    },
    q: {
      check_attributes: {
        cite: 'url',
        style: 'any',
      },
    },
    applet: {
      remove: 1,
    },
    span: {
      check_attributes: {
        style: 'any',
      },
    },
    rp: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    spacer: {
      remove: 1,
    },
    source: {
      remove: 1,
    },
    aside: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'div',
    },
    frame: {
      remove: 1,
    },
    section: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'div',
    },
    body: {
      check_attributes: {
        style: 'any',
      },
      remove: 0,
      rename_tag: '',
    },
    ol: {
      check_attributes: {
        style: 'any',
      },
    },
    nobr: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    html: {
      check_attributes: {
        style: 'any',
      },
      remove: 0,
      rename_tag: '',
    },
    summary: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    var: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    del: {
      check_attributes: {
        style: 'any',
      },
      remove: 1,
    },
    blockquote: {
      check_attributes: {
        cite: 'url',
        style: 'any',
      },
    },
    style: {
      remove: 0,
      rename_tag: '',
      set_attributes: {
        type: 'text/css',
      },
    },
    device: {
      remove: 1,
    },
    meter: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    h3: {
      check_attributes: {
        style: 'any',
      },
      add_class: {
        align: 'align_text',
      },
    },
    textarea: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    embed: {
      remove: 1,
    },
    hgroup: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'div',
    },
    font: {
      check_attributes: {
        style: 'any',
      },
      remove: 0,
      rename_tag: '',
      add_class: {
        size: 'size_font',
      },
    },
    tt: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    noembed: {
      remove: 1,
    },
    thead: {
      check_attributes: {
        style: 'any',
      },
      add_class: {
        align: 'align_text',
      },
    },
    blink: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    plaintext: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    xml: {
      remove: 1,
    },
    h6: {
      check_attributes: {
        style: 'any',
      },
      add_class: {
        align: 'align_text',
      },
    },
    param: {
      remove: 1,
    },
    th: {
      check_attributes: {
        rowspan: 'numbers',
        colspan: 'numbers',
        abbr: 'any',
        align: 'any',
        axis: 'any',
        bgcolor: 'any',
        char: 'any',
        charoff: 'any',
        headers: 'any',
        scope: 'any',
        valign: 'any',
        width: 'any',
        style: 'any',
      },
      add_class: {
        align: 'align_text',
      },
    },
    legend: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    hr: {
      check_attributes: {
        style: 'any',
      },
    },
    label: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    dl: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'div',
    },
    kbd: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    listing: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'div',
    },
    dt: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    nextid: {
      remove: 1,
    },
    pre: {
      check_attributes: {
        style: 'any',
      },
      remove: 0,
      rename_tag: '',
    },
    center: {
      check_attributes: {
        style: 'any',
      },
      remove: 0,
      rename_tag: '',
    },
    audio: {
      remove: 1,
    },
    datalist: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    samp: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    col: {
      remove: 1,
    },
    article: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'div',
    },
    cite: {
      check_attributes: {
        style: 'any',
      },
    },
    link: {
      check_attributes: {
        href: 'any',
        rel: 'any',
        type: 'any',
      },
      remove: 0,
    },
    script: {
      remove: 1,
    },
    bdo: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    menu: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'ul',
    },
    colgroup: {
      remove: 1,
    },
    ruby: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    h2: {
      check_attributes: {
        style: 'any',
      },
      add_class: {
        align: 'align_text',
      },
    },
    ins: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    p: {
      check_attributes: {
        align: 'any',
        width: 'any',
        style: 'any',
      },
      add_class: {
        align: 'align_text',
      },
    },
    sub: {
      check_attributes: {
        style: 'any',
      },
      remove: 0,
      rename_tag: '',
    },
    comment: {
      check_attributes: {
        style: 'any',
      },
      remove: 0,
      rename_tag: '',
    },
    frameset: {
      remove: 1,
    },
    optgroup: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'span',
    },
    header: {
      check_attributes: {
        style: 'any',
      },
      rename_tag: 'div',
    },
  },
};

export default Wysihtml5ParserRules;
